import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { BANNER_URL } from './data';
import { useBooking } from './BookingContext';
import { useLanguage } from './i18n/LanguageContext';
export function Hero() {
  const {
    openBooking
  } = useBooking();
  const {
    t
  } = useLanguage();
  return <section id="inicio" className="w-full pt-16 sm:pt-20 bg-[#faf0e7]" data-id="element-180" data-mp="4mrxpamcehpz">
      <div className="relative w-full" data-id="element-181" data-mp="12a0kra1zryu3">
        <img src={BANNER_URL} alt={t.hero.bannerAlt} className="block w-full h-auto" data-id="element-182" data-mp="128z0cez35zzp" />

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        ease: [0.22, 1, 0.36, 1]
      }} className="absolute hidden lg:block top-[75%] left-[70%] max-w-[360px] text-center w-[294px] h-[63px]" data-id="element-183" data-mp="xbpaiy7sbmbc">
          <div className="flex items-center justify-center gap-2 text-mid mb-3" data-id="element-184" data-mp="3d1a8vl7kyddt">
            <span className="flex items-center gap-0.5 text-champagne" data-id="element-185" data-mp="3cz5w0drpe41e">
              {Array.from({
              length: 5
            }).map((_, i) => <Star key={i} className="w-3 h-3 fill-current" strokeWidth={0} data-id="element-186" data-mp="3j7zh7oa6s2jb" data-mpi={i} />)}
            </span>
            <span className="font-body font-medium text-[8px] tracking-[1.5px] uppercase whitespace-nowrap" data-id="element-187" data-mp="3o859n6oa5t2g">
              {t.hero.badge}
            </span>
          </div>
          <motion.button type="button" onClick={openBooking} whileHover={{
          y: -2
        }} className="metallic-reserve-button inline-block w-full px-4 py-3 font-body text-[9px] font-semibold uppercase tracking-[3px] text-white outline-none focus-visible:ring-2 focus-visible:ring-champagne focus-visible:ring-offset-2 focus-visible:ring-offset-[#faf0e7]" data-id="element-188" data-mp="39cpfz2rm3z6l">
            {t.hero.cta}
          </motion.button>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.15,
      duration: 0.55,
      ease: [0.22, 1, 0.36, 1]
    }} className="lg:hidden px-5 py-6 text-center border-t border-gold-ultra-light bg-[#faf0e7]" data-id="element-189" data-mp="2vi56bc9fgo1p">
        <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-mid mb-4" data-id="element-190" data-mp="s2b6puz5ad3k">
          <span className="flex items-center gap-0.5 text-champagne" data-id="element-191" data-mp="nb1imyt8vhts">
            {Array.from({
            length: 5
          }).map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-current" strokeWidth={0} data-id="element-192" data-mp="ichyn3y7og42" data-mpi={i} />)}
          </span>
          <span className="font-body font-medium text-[9px] tracking-[2px] uppercase" data-id="element-193" data-mp="deylk7d929dp">
            {t.hero.badge}
          </span>
        </div>
        <motion.button type="button" onClick={openBooking} whileTap={{
        scale: 0.98
      }} className="metallic-reserve-button inline-block w-full px-6 py-4 font-body text-[10px] font-semibold uppercase tracking-[4px] text-white outline-none focus-visible:ring-2 focus-visible:ring-champagne focus-visible:ring-offset-2 focus-visible:ring-offset-[#faf0e7]" data-id="element-194" data-mp="1622jxthu7pgi">
          {t.hero.cta}
        </motion.button>
      </motion.div>
    </section>;
}